var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTrash = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete-bin-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1667 4.99996H18.3334V6.66663H16.6667V17.5C16.6667 17.9602 16.2936 18.3333 15.8334 18.3333H4.16669C3.70645 18.3333 3.33335 17.9602 3.33335 17.5V6.66663H1.66669V4.99996H5.83335V2.49996C5.83335 2.03973 6.20645 1.66663 6.66669 1.66663H13.3334C13.7936 1.66663 14.1667 2.03973 14.1667 2.49996V4.99996ZM15 6.66663H5.00002V16.6666H15V6.66663ZM7.50002 3.33329V4.99996H12.5V3.33329H7.50002Z",
    fill: "#FF2727"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTrash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/trash.a12023a8.svg";
export { ForwardRef as ReactComponent };